import { useIsMobile } from "@/hooks/useIsMobile";
import SvgDelAttach from "../consult-form-icons/SvgDelAttach";
import AudioPlayer from "./audio-player/AudioPlayer";
import { TempFile } from "@/app/components/common-form-builder/common-fields/hook-upload-files/upload-files-helpers/upload";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  filesUrls?: TempFile[];
  handleRemove?: (index: number) => void;
  handleRemoveFile: (index: number) => void;
  audioUrls: string[];
  setAudioUrls: (urls: string[]) => void;
}

const ConsltAttachments: React.FC<Props> = ({
  filesUrls,
  handleRemoveFile,
  audioUrls,
  setAudioUrls,
}) => {
  const mobile = useIsMobile();
  const t = useTranslation();
  const handleRemoveAudio = (index: number) => {
    const currUrls = [...audioUrls];
    currUrls.splice(index, 1);
    setAudioUrls(currUrls);
  };
  return (
    <>
      <div className="consult-subtitle">
        {filesUrls?.length === 0 && audioUrls.length === 0
          ? t.you_can_also
          : t.attachments}
      </div>
      {audioUrls?.map((url, index) => (
        <AudioPlayer
          key={url}
          audioUrl={url}
          removeAudio={() => handleRemoveAudio(index)}
        />
      ))}
      <div className="consult-attach-section">
        {filesUrls?.map((f, index) => (
          <div className="consult-attachment text-nowrap" key={f.id}>
            {f.name}
            <SvgDelAttach
              mobile={mobile}
              onClick={() => handleRemoveFile(index)}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default ConsltAttachments;
